var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _ellipse, _path22, _path23, _path24, _path25, _path26, _path27, _rect2, _path28, _path29, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShibaStubborn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496.21 426.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-13{fill:#fff;}.cls-1{opacity:0;}.cls-2{fill:#c37c12;}.cls-3{fill:#dbd2c7;}.cls-4{fill:#ede4d6;}.cls-5{fill:#d38f19;}.cls-6{fill:#ca3720;}.cls-7{fill:#a5a4a4;}.cls-8{fill:#c97e1c;}.cls-9{fill:#eee9d7;}.cls-10{fill:#743f2a;}.cls-11{fill:#cfd6e6;}.cls-12{fill:#3b3a3a;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.63,
    width: 494.58,
    height: 426.54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M345.29,300.64s34,7.43,49.55,3c16.25-4.66,23.45-9.57,27.87-24.28,1.73-5.73-15.67-12.41-17.2-31.55s9.64-34.81,30.73-38.21c19.82-3.2,53.46,14.29,57.84,46.22,3.76,27.34-13.88,69.21-56.82,83.15-26.92,8.75-50.44,3.6-77.14-17S345.29,300.64,345.29,300.64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M271.23,295.9c-4.13,1.1-14.12,7.4-15.57,17.15s21.16,41.82,21.16,41.82L383,359.27s25.61-33.56,20.94-45.08c-3.49-8.62-15.77-14.75-15.77-14.75l-58.4-26.14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M253.32,357.3a17.68,17.68,0,0,1,35.36,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M364.53,361.21a17.68,17.68,0,1,1,35.14,3.93Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M307.58,304.93l44.73,4.44s38.72,5.54,42.63-27.74S381,149,381,149H279s-20,106-12.81,128.19S307.58,304.93,307.58,304.93Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M276.83,381c0,1-.09,1.92-.17,2.77-1.67,17.2-9.92,23.86-10.51,29.41s16.42,10.55,23.17,8.88,11.75-33.29,12.86-38.84c.09-.44.2-1.28.32-2.47C294.33,384.06,284.67,384.46,276.83,381Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M268.89,278.85c-8.06-17.75,19-120.87,19-120.87l-21.77-9s-4.89,18.32-7.46,26.64,3.61,94.33,7.46,121c3.66,25.31,11.35,65.64,10.68,84.35,7.84,3.5,17.5,3.1,25.67-.25,1.44-14,5.08-75.78,5.08-75.78S277,296.61,268.89,278.85Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M357.55,386.53c.06.48.11.85.16,1.09,1.11,5.54,6.1,37.17,12.86,38.84s23.76-3.33,23.17-8.88-8.84-12.21-10.5-29.41c-.1-.94-.15-2-.18-3.05a64.6,64.6,0,0,1-8.75,3.24A23.68,23.68,0,0,1,357.55,386.53Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M393.74,301.05c3.85-26.64,10-112.65,7.46-121s-7.46-26.64-7.46-26.64l-21.76,9s27.09,103.11,19,120.87-38.69,26.08-38.69,26.08,3.93,66.59,5.24,77.16a23.68,23.68,0,0,0,16.76,1.83,64.6,64.6,0,0,0,8.75-3.24C382.47,366.29,390.1,326.24,393.74,301.05Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M372.05,162.86c-.62,6-21.93,8.6-47.58,5.91s-45.94-9.71-45.31-15.67,21.93-8.6,47.58-5.9S372.68,156.9,372.05,162.86Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M333,173.49a16.54,16.54,0,0,1-5.32-32.19,1.5,1.5,0,0,1,1,2.84,13.54,13.54,0,0,0-8.44,17.17,13.47,13.47,0,0,0,17.21,8.39c1.16.07,4.44.11,4.44.11s-.39,1.68-3.51,2.78A15.91,15.91,0,0,1,333,173.49Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M310.25,32.63c1.72-.86,45.14-.34,66.94,5.43,0,0,41.43,52.37,41.43,70.61,0,9.64-18.76,51.9-31.79,55.5s-44-6.51-58.78-9.07-47.54,4.77-58.85-.57c-13.24-6.25-17.26-45.83-15.77-56.06S283.32,46.09,310.25,32.63Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M305.52,51.68s8.57,14.45,13.2,14.18,6.82-5.73,5.18-11.45S310.31,46.5,305.52,51.68Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M367.86,51.68s-8.57,14.45-13.2,14.18-6.81-5.73-5.18-11.45S363.07,46.5,367.86,51.68Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M376,37.76S396.68,4.25,408.68,7.25s9,41.16,6,53.43-6.5,22.08-6.5,22.08Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M385.88,51.61S381.42,37,389.05,25.79,405.41,13,407.59,14.34s7.36,23.84,2.72,37.27S396.66,68,396.66,68Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M388.21,55.15s11.49-20.92,13.12-19.53-2.92,21.09-9.1,25.66Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M307.58,33.64S290-1.59,277.74.32,265.1,40.51,267,53s4.51,22.57,4.51,22.57Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M296.47,46.55s5.76-14.19-.84-26S280.49,6.32,278.19,7.48s-9.46,23.08-6.05,36.88,12.12,17.58,12.12,17.58Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M293.83,49.87S284.27,28,282.52,29.24s1,21.26,6.76,26.37Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M409.94,110c-1.29-10.54-13.59-24.23-21.73-24.6s-18.76,6.76-30.6,8.73-32.26-2-45.39-3.9-17-11.55-27.2-14.65-24.44,14.65-25.91,24.81c-1.3,8.94.18,23.3,8.32,37s25.36,17.92,25.36,17.92.92.27,2.53.71c12.06-.84,24.93-2.26,32.73-.9,9.42,1.63,25.45,6.34,39.21,8.6C395.19,158,411.2,120.22,409.94,110Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 330.04,
    cy: 130.98,
    rx: 8.84,
    ry: 19.41,
    transform: "translate(155.7 440.32) rotate(-82.24)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M0,327.07,318.14,167s5.26-2.52,7.55,1.84-.68,6.08-.68,6.08L0,413.64Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M354.71,74.58s12.81-.55,22.35,1.63c0,0-3.82,6.55-11.18,6.55S354.71,74.58,354.71,74.58Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M316.7,72.11s-12.6-2.38-22.35-1.59c0,0,2.83,7,10.12,8.07S316.7,72.11,316.7,72.11Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M319.19,78.12c6.27-5.79,23.17-7.36,31.62,1.91s16.62,35.44,12.81,45-14.59,11.73-33.58,9c-16.66-2.36-28-6.59-31.3-16.4S312.1,84.66,319.19,78.12Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M315,79.84s8.87,10,19.78,10.36S356.22,86,356.22,86s-7-14.14-18.69-15.75S315,79.84,315,79.84Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M349.82,91.77a15.54,15.54,0,1,1-30.93-3c.83-8.54,6.93-9.2,15.47-8.37S350.65,83.23,349.82,91.77Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 328,
    y: 104.4,
    width: 9.13,
    height: 1,
    transform: "translate(203.28 428.76) rotate(-85.74)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M341,125l-.11-.64c0-.13-2.19-13.1-8.72-14.37s-12.87,12.2-12.93,12.33l-.3.64L313,117.15l.7-.71,4.87,4.78c1.4-2.79,7.26-13.51,13.72-12.26s8.87,11.81,9.4,14.56l7-3.09.4.92Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M307.28,290.37c-13-9.63-18-31.6-18-31.82l1-.21c0,.21,4.93,21.82,17.65,31.23Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M344,293.05l-.33-.94c.17-.06,17.69-6.47,21.7-26l1,.21C362.24,286.4,344.2,293,344,293.05Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShibaStubborn);
export default __webpack_public_path__ + "static/media/shiba-stubborn.87082c187a1cd18d3f817541254c55d0.svg";
export { ForwardRef as ReactComponent };